import { useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { PopoverBody } from "react-bootstrap";
import type { Coordinate } from "ol/coordinate";
import { PopupOverlay } from "../../../../reactOL/overlays";
import type { RouteLineSummary } from "../RouteLineSummary";
import RouteLineTable from "./RouteLineTable";
import { useLayerService } from "../../../../../hooks";
import { useRouteLineContext } from "../../../../../context/MapViews/RouteLine/RouteLineContext";

interface RouteLineSummaryOverlayProps {
  summaries: RouteLineSummary[] | null;
  coordinate: Coordinate | null;
  onClose: () => void;
}

const RouteLineSummaryOverlay = ({
  summaries,
  coordinate,
  onClose,
}: RouteLineSummaryOverlayProps) => {
  const { setRouteLines } = useRouteLineContext();

  const layerService = useLayerService();

  const handleView = useCallback(
    async (ids: number[]) => {
      const routeLines = await layerService.GetRouteLineByIds(ids);
      setRouteLines(routeLines);
    },
    [layerService, setRouteLines],
  );

  return (
    <PopupOverlay
      width="300px"
      coordinate={coordinate ?? undefined}
      placement="top"
      autoPanMargin={80}
    >
      <PopoverBody className="p-0" style={{ borderRadius: 7 }}>
        <div
          className="bg-primary text-white p-2 d-flex align-items-center justify-content-between"
          style={{ borderTopLeftRadius: 7, borderTopRightRadius: 7 }}
        >
          <span className="fw-semibold mx-auto">Route Lines</span>
          <FontAwesomeIcon
            icon={faTimes}
            role="button"
            aria-label="Close"
            onClick={onClose}
            style={{ cursor: "pointer", fontSize: "0.9rem" }}
          />
        </div>
        {summaries && (
          <RouteLineTable summaries={summaries} onView={handleView} />
        )}
      </PopoverBody>
    </PopupOverlay>
  );
};

export default RouteLineSummaryOverlay;
